import { enumLabel } from "helpers/system";
import compact from "lodash/compact";
import React from "react";
import configByName from "./configs/configByName";
import Template, { statuses } from "./template";

class Truck extends Template {
    infoText = () => {
        const { carTypeLabel, brand } = this.state.truckData || {};
        if (!!carTypeLabel || !!brand) {
            return (
                <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-5">
                    <small className="text-muted">{compact([brand, carTypeLabel]).join(", ")}</small>
                </div>
            );
        }
        return null;
    };

    getItem = ({ value }) => {
        if (!this.props.tripCouplingEnabled) {
            this.props.updateCarAvailability(value);
        }
        if (!value) {
            return this.setState({ truckData: null });
        }
        const { enums } = this.props;
        this.props
            .getItem({ id: value })
            .then((res) => {
                if (res) {
                    const { brandTypeId, typeId } = res;

                    const valueData = {
                        carTypeLabel: enumLabel(enums.carType, typeId),
                        brand: enumLabel(enums.carBrandType, brandTypeId),
                    };
                    this.setState({ truckData: valueData });
                }
            })
            .catch(() => this.setState({ status: statuses.notFound }));
    };

    render() {
        const { config, value, carStatus } = this.props;
        const extendValue = { carStatus };
        return (
            <div className="form-group">
                {this.renderSelect({
                    ...config.carId,
                    value,
                    extendValue,
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row",
                    onNotFoundHandler: () => {
                        this.setState({ truckData: null });
                        this.setValue({ name: config.carId.inputProps.name, value: null });
                    },
                })}
                <div className="row">{this.infoText()}</div>
            </div>
        );
    }
}

const Configured = (props) => (
    <Truck {...props} {...configByName.truck(props.tripCouplingEnabled, props.firstPoint, props.action)} />
);

export default Configured;
